import "./Tabs.scss";

const Tabs = ({ tabs = [], active, onChange }) => {
  return (
    <div className="tabs">
      {tabs.map((tab) => (
        <button
          key={tab}
          className={`tab me-5 ${active === tab ? "active" : ""}`}
          onClick={() => onChange && onChange(tab)}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
